import React, { useState } from 'react';
import { Button, Dialog, DialogActions, DialogContent, Grid, LinearProgress, Paper, Typography } from '@mui/material';
import UploadIcon from 'mdi-material-ui/Upload'
//import CalendarPlusIcon from 'mdi-material-ui/CalendarPlus'
//import FlagCheckeredIcon from 'mdi-material-ui/FlagCheckered'
import JHApi from "../../../utils/JHApi"
import { JourneyClasses } from '../../../styles/JourneyClasses';
import VisibilityIcon from '@mui/icons-material/Visibility';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';

import journeyStep1 from '../../../assets/images/journeyStep1.png';
import journeyStep2 from '../../../assets/images/journeyStep2.png';
import journeyStep4 from '../../../assets/images/journeyStep4.png';

import journeyStep1W from '../../../assets/images/webp/journeyStep1.webp';
import journeyStep2W from '../../../assets/images/webp/journeyStep2.webp';
import journeyStep4W from '../../../assets/images/webp/journeyStep4.webp';
//import GoalsForm from './GoalsForm';
import { Fields } from '../../Fields';
import { FIELD_TYPES, SENIORITIES, showDateTimeFromString } from '../../../utils/utils';
import DoneIcon from '@mui/icons-material/Done';
import clsx from 'clsx';

function ProfileInfoDialog (props){
    const journeyData = props.journeyData || {}
    const completed = journeyData.completed || {}

    const [newData, setNewData] = useState({});
    const [error, setError] = useState();
    const [disabled, setDisabled] = useState(false);

    const getValue = (name, defaultValue) => {
        if (newData[name] !== undefined){
            return newData[name]
        } else if (journeyData[name] !== undefined){
            return journeyData[name]
        } else {
            return defaultValue
        }
    }

    const handleChangeTitle = (titleGroup, titleCategories) => {
        if (getValue('title', '')){
            setNewData({...newData, titleGroup, titleCategories})
        } else {
            setNewData({...newData, title:titleGroup, titleGroup, titleCategories})
        }
    }

    const handleChangeField = e => {
        setNewData({...newData,[e.target.name]: e.target.value})
    };

    const handleSaveFields = e => {
        e.preventDefault();

        let paramsToPass = {data:newData}

        paramsToPass.data.completed = {...completed, dataChecked:true}

        if (props.isAdmin){
            paramsToPass.userId = props.userId
        }
    
        setDisabled(true)

        JHApi.updatePersonalJourneyData(paramsToPass,(response)=>{
            props.setJourneyData(response.personaljourney);
            setDisabled(false)
            handleCloseDialog()
        }, (error) => {
            setError(error)
            setDisabled(false)
        })
    }

    const handleCloseDialog = () => {
        props.handleClose()
    }

    const fields = [
        {name:'email', label:'Email', inputType:'email', defaultValue: '', type:FIELD_TYPES.TEXT, sm:12, required: true},
        {name:'phone', label:'Phone', inputType:'tel', defaultValue: '', type:FIELD_TYPES.TEXT, sm:12, required: true},
        {name:'first_name', label:'First name', defaultValue: '', type:FIELD_TYPES.TEXT, sm:12, required: true},
        {name:'last_name', label:'Last name', defaultValue: '', type:FIELD_TYPES.TEXT, sm:12, required: true},
        {name:'titleGroup', label:'Professional Title', type:FIELD_TYPES.TITLE, handleChangeTitle, sm:12, required: true},
        {name:'title', label:'Professional Title (Free Text)', defaultValue: '', hide: (!getValue('titleGroup', '') && !getValue('title', '')) , type:FIELD_TYPES.TEXT, sm:12, required: true},
        {name:'seniorityLevel', label:'Seniority', defaultValue: '', type:FIELD_TYPES.SELECT, options:SENIORITIES, sm:12}
    ]

    return (
        <Dialog onClose={handleCloseDialog} open={props.open} fullWidth maxWidth="xs">
            <form onSubmit={handleSaveFields}>
                <DialogContent dividers>
                    {(error)&&<Typography color="error">{error}</Typography>}
                    <Fields fields={fields} getValue={getValue} handleChange={handleChangeField}/>
                </DialogContent>
                <DialogActions>
                    <Button disabled={disabled} onClick={handleCloseDialog} color="primary" size="small" aria-label="Cancel">
                        Cancel
                    </Button>
                    <Button
                        disabled={disabled}
                        type="submit"
                        variant="outlined"
                        color="primary"
                        size="small"
                        aria-label='Save'
                    >
                        Save
                    </Button>
                </DialogActions>
            </form>
        </Dialog>
    )
}

export default function JourneyOnbordingFirstSteps(props) {
    const journeyData = props.journeyData || {}
    const completed = journeyData.completed || {}

    const [uplaodMessage, setUplaodMessage] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [showProfileInfo, setShowProfileInfo] = useState(false);

    const disabled = props.disabled || isLoading

    /*useEffect(() => {
        if (isFetchingMeetings){
            let paramsToPass = {}

            JHApi.fetchMeetingSlots(paramsToPass,(response)=>{
                setCalendar(response||[])
                setIsFetchingMeetings(false)
            }, (error) => {
                setIsFetchingMeetings(false)
            })
        }
    }, [isFetchingMeetings]);*/

    const handlUploadCV = event => {
        const maxUploadResumeSize = 500 * 1024; // 500 KB
        const file = event.target.files[0];

        if (!file) {
            return null
        }

        if(file.size > maxUploadResumeSize){
            setUplaodMessage('File too big - 500 KB Max')
            return null
        }
        
        const extension =  file.name.split('.').pop();
        if(!extension.match(/docx|pdf/ig)){
            setUplaodMessage('Invalid extension')
            return null
        }

        setIsLoading(true)
        setUplaodMessage('Uploading...')

        const data = new FormData()
        data.append('file', file, file.name)

        if (props.isAdmin){
            data.append('userId', props.userId)
        }

        data.append('isOnboarding', true)

        JHApi.uploadPublishCVFile(data, (response)=>{
            props.setJourneyData(response.personaljourney);
            setIsLoading(false)
            setUplaodMessage('')
        }, (error)=>{
            setIsLoading(false)
            setUplaodMessage(error.message)
        });
    }

    const handleScheduleMeeting = () => {
        let paramsToPass = {data:{}}

        paramsToPass.data.completed = {...completed, firstMeeting:true}

        if (props.isAdmin){
            paramsToPass.userId = props.userId
        }
    
        setIsLoading(true)

        JHApi.updatePersonalJourneyData(paramsToPass,(response)=>{
            props.setJourneyData(response.personaljourney);
            setIsLoading(false)

            const phone = window.OFFICE_PHONE;
            const msg = "היי, הצטרפתי לשירות של JobHunt!\n\nאשמח לקבוע פגישה ראשונה";
            const meetingLink = `https://wa.me/${phone}?text=${encodeURIComponent(msg)}`;

            window.open(meetingLink, '_self');
        }, (error) => {
            /*setError(error)
            setIsLoading(false)*/
        })
    }

    const handleUseThisCV = () => {
        let paramsToPass = {}

        if (props.isAdmin){
            paramsToPass.userId = props.userId
        }
    
        setIsLoading(true)

        JHApi.useOrigianlCV(paramsToPass,(response)=>{
            props.setJourneyData(response.personaljourney);
            setIsLoading(false)
        }, (error) => {
            /*setError(error)
            setIsLoading(false)*/
        })
    }

    /*const handleDateTimeSelected = (date, time) => {
        let paramsToPass = {date, time}
        if (isAdmin){
            paramsToPass.userId = userId
        }

        setIsLoading(true)
        JHApi.scheduleMeeting(paramsToPass,(response)=>{
            setCalendar([])
            setIsLoading(false)
        }, (error) => {
            setIsLoading(false)
        })
    }*/

    const stepsCompleted = (completed.uploadCV?1:0) + (completed.firstMeeting?1:0) + (completed.dataChecked?1:0)

    const classes = JourneyClasses();

    return (
        <div>
            <ProfileInfoDialog {...props} open={showProfileInfo} handleClose={()=>setShowProfileInfo(false)}/>
            {/*<GoalsForm {...props} open={showGoals} handleCloseDialog={()=>setShowGoals(false)} />*/}
            <Paper style={{marginBottom: 32, height: 'initial'}} className={classes.block} elevation={1}>
                <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16}}>
                    <Typography variant='h3' style={{fontSize: 18, fontWeight: 500, lineHeight: '28px'}}>Your Progress</Typography>
                    {(stepsCompleted < 3) && <Typography style={{color: '#6b7280', fontSize: 14, lineHeight: '20px'}}>Step {stepsCompleted +1} of 3</Typography>}
                </div>
                <LinearProgress style={{height: 8, borderRadius: 8}} variant="determinate" value={(completed.uploadCV?33.3:0) + (completed.firstMeeting?33.3:0) + (completed.dataChecked?33.3:0)} />
            </Paper>

            <Grid container spacing={1}>
                <Grid item sm={4} xs={12}>
                    <Paper style={{textAlign: 'center'}} className={classes.block} elevation={1}>
                        <div style={{display: 'flex', flexDirection: 'column'}}>
                        <picture className={classes.stepPicture}>
                            <source type="image/webp" srcSet={journeyStep1W} />
                            <img  className={classes.stepImg} src={journeyStep1} alt='Check Data'/>
                        </picture>      
                        <div className={classes.stepBadgeContainer}>
                            <span className={clsx(classes.stepBadge, completed.dataChecked&&classes.stepCompleted)}>{completed.dataChecked?<DoneIcon/>:1}</span>
                        </div>
                        <Typography className={classes.stepTtile} variant='h3'>
                            Check your data
                        </Typography>
                        <Typography className={classes.stepText}>
                            Check your data and contact information
                        </Typography>
                        </div>
                        <Button onClick={()=>setShowProfileInfo(true)} className={classes.stepButton} disabled={disabled} variant="contained" color="primary" component="span" aria-label="Schedule Meeting" size="small">
                            <VisibilityIcon style={{marginRight: 8}}/>
                            Check your data
                        </Button>
                    </Paper>
                </Grid>
                <Grid item sm={4} xs={12}>
                    <Paper style={{textAlign: 'center' }} className={classes.block} elevation={1}>
                        <div style={{display: 'flex', flexDirection: 'column'}}>
                        <picture className={classes.stepPicture}>
                            <source type="image/webp" srcSet={journeyStep4W} />
                            <img  className={classes.stepImg} src={journeyStep4} alt='Upload CV'/>
                        </picture>      
                        <div className={classes.stepBadgeContainer}>
                            <span className={clsx(classes.stepBadge, completed.uploadCV&&classes.stepCompleted)}>{completed.uploadCV?<DoneIcon/>:2}</span>
                        </div>
                        <Typography className={classes.stepTtile} variant='h3'>
                            Share your file with us
                        </Typography>
                        <Typography className={classes.stepText}>
                            Upload your CV and let our experts review it to maximize your job search potential.
                        </Typography>
                        {journeyData.CVUrl&&<>
                            <Typography style={{marginBottom:8}}><a target='_blank' rel="noopener noreferrer" href={journeyData.CVUrl}>{journeyData.CVUrlUploadTime?('CV - '+showDateTimeFromString(journeyData.CVUrlUploadTime, true)):'Uploaded CV'}</a></Typography>
                            {!completed.uploadCV&&<Button onClick={handleUseThisCV} style={{marginBottom:8}} className={classes.stepButton} disabled={disabled} variant="outlined" color="primary" component="span" aria-label="Use this CV" size="small">
                                <DoneIcon style={{marginRight: 8}}/>
                                Use This CV
                            </Button>}
                        </>}
                        </div>
                        <Typography>
                            {uplaodMessage}
                        </Typography>
                        <input
                            id="contained-button-file"
                            accept=".doc,.docx"
                            type="file"
                            style={{display:"none"}}
                            onChange={handlUploadCV}
                        />
                        <label htmlFor="contained-button-file">
                            <Button className={classes.stepButton} disabled={disabled} variant="contained" color="primary" component="span" aria-label="Upload" size="small">
                                <UploadIcon style={{marginRight: 8}}/>
                                Upload CV
                            </Button>
                        </label>
                    </Paper>
                </Grid>
                <Grid item sm={4} xs={12}>
                    <Paper style={{textAlign: 'center'}} className={classes.block} elevation={1}>
                        <div style={{display: 'flex', flexDirection: 'column'}}>
                        <picture className={classes.stepPicture}>
                            <source type="image/webp" srcSet={journeyStep2W} />
                            <img  className={classes.stepImg} src={journeyStep2} alt='Schedule Meeting'/>
                        </picture>      
                        <div className={classes.stepBadgeContainer}>
                            <span className={clsx(classes.stepBadge, completed.firstMeeting&&classes.stepCompleted)}>{completed.firstMeeting?<DoneIcon/>:3}</span>
                        </div>
                        <Typography className={classes.stepTtile} variant='h3'>
                            Let's set up a meeting
                        </Typography>
                        <Typography className={classes.stepText}>
                            Schedule a meeting with our career experts to discuss your goals
                        </Typography>
                        </div>
                        <Button /*href={meetingLink}*/ onClick={handleScheduleMeeting} className={classes.stepButton} disabled={disabled} variant="contained" color="primary" aria-label="Schedule Meeting" size="small">
                            <WhatsAppIcon style={{marginRight: 8}}/>
                            Schedule Meeting
                        </Button>
                        {/*<List dense component="nav">
                            {calendar.map((day) => (
                                <Fragment key={day.date}>
                                    <ListItem button onClick={()=>handleDateSelected(day.date)}>
                                        <ListItemText primary={dateAsString(new Date(day.date))}/>
                                    </ListItem>
                                    <Collapse in={day.date === selectedDate} timeout="auto" unmountOnExit>
                                        <List dense component="div" disablePadding>
                                            {day.times.map((time) => (
                                                <ListItem key={time} button style={{paddingLeft: 42}} onClick={()=>handleDateTimeSelected(day.date, time)}>
                                                    <ListItemText primary={time}/>
                                                </ListItem>
                                            ))}
                                        </List>
                                    </Collapse>
                                </Fragment>
                            ))}
                        </List>*/}
                    </Paper>
                </Grid>
                {/*<Grid item sm={4} xs={12}>
                    <Paper style={{textAlign: 'center'}} className={classes.block} elevation={1}>
                        <picture className={classes.stepPicture}>
                            <source type="image/webp" srcSet={journeyStep3W} />
                            <img  className={classes.stepImg} src={journeyStep3} alt='Set Goals'/>
                        </picture>      
                        <div className={classes.stepBadgeContainer}>
                            <span className={classes.stepBadge}>3</span>
                        </div>
                        <Typography className={classes.stepTtile} variant='h3'>
                            Goals
                        </Typography>
                        <Typography className={classes.stepText}>
                            Define your career objectives and preferred job requirements
                        </Typography>
                        <Button onClick={()=>setShowGoals(true)} className={classes.stepButton} disabled={disabled} variant="contained" color="primary" component="span" aria-label="Schedule Meeting" size="small">
                            <FlagCheckeredIcon style={{marginRight: 8}}/>
                            Set Goals
                        </Button>
                    </Paper>
                </Grid>*/}
            </Grid>
        </div>
    )
}